<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    
    <el-container>
      <el-header>{{ coupon.name }}</el-header>
    </el-container>

    <el-button type="primary" size="mini" @click="dialogVisible = true" style="margin: 10px 0px 0px 20px;" v-if="type_value != 1">
      分享语
    </el-button>

    <el-form
      :model="coupon"
      status-icon
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="适用群体">
        <el-radio-group
          v-model="coupon.group"
          @change="setCouponGroup(Number($event))" :disabled="type_value ==1">
          <el-radio :label="2">全体用户</el-radio>
          <el-radio :label="7">指定人群</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <el-row v-if="showCouponGroupList">
      <el-col :span="24">
        <el-button
          style="padding: 10px; margin: 20px"
          type="primary"
          size="mini"
          @click="
            search.chooseOrgVisible = true;
            search.query.type = 1;
            searchData();
          "
          v-if="type_value != 1"
        >
          添加指定商品付费人群
        </el-button>
        <el-button
          style="padding: 10px; margin: 20px"
          type="primary"
          size="mini"
          @click="
            search.chooseOrgVisible2 = true;
            search.query.type = 2;
            searchData();
          "
          v-if="type_value != 1"
        >
          添加个人
        </el-button>
      </el-col>
      <el-table
        v-if="showCouponGroupList"
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          prop="target_id"
          label="ID"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="类型"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column label="名称" align="center" min-width="50%">
          <template slot-scope="{ row }">
            <div>
              {{ row.target_name }}
              {{
                row.start_at || row.end_at
                  ? "【支付时间段：" + row.start_at + "~" + row.end_at + "】"
                  : ""
              }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="couponProductDelete(row.id)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row v-if="showCouponGroupList">
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="添加指定商品付费人群"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="mini"
            v-model="search.query.search"
            placeholder="请输入标题"
            clearable
            @blur="
              search.query.type = 1;
              searchData();
            "
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              searchData();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <el-tabs v-model="search.activeName" @tab-click="handleClick">
        <el-tab-pane label="体验营" name="19"></el-tab-pane>
        <el-tab-pane label="私教班" name="24"></el-tab-pane>
        <el-tab-pane label="专题课" name="12"></el-tab-pane>
        <el-tab-pane label="普通课程" name="1"></el-tab-pane>
        <el-tab-pane label="直播课" name="3"></el-tab-pane>
        <el-tab-pane label="工作坊" name="5"></el-tab-pane>
        <el-tab-pane label="商品" name="0"></el-tab-pane>
      </el-tabs>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              size="small"
              @click="
                targetOrderTimedialogVisible = true;
                search.query.target_type == 0
                  ? (saveProduct.type = 1)
                  : (saveProduct.type = 0);
                saveProduct.course_type = row.course_type;
                saveProduct.target_id = row.id;
              "
            >
              添加
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="targetOrderTimedialogVisible"
      width="70%"
      :before-close="targetOrderTimedialogVisibleHandleClose"
    >
      <el-radio-group v-model="saveProduct.radio">
        <el-radio :label="0">全部时间段</el-radio>
        <el-radio :label="1">
          指定时间段
          <el-date-picker
            v-model="saveProduct.start_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
          >
          </el-date-picker>
          ~
          <el-date-picker
            v-model="saveProduct.end_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            default-time="23:59:59"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="targetOrderTimedialogVisibleHandleClose()"
          >取 消</el-button
        >
        <el-button type="primary" @click="saveTarget()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="添加个人"
      :visible.sync="search.chooseOrgVisible2"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="mini"
            v-model="search.query.search"
            placeholder="请输入"
            clearable
            @blur="
              search.query.type = 2;
              searchData();
            "
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              searchData();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
          prop="nickname"
          label="昵称"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.avatar" style="width: 40px" alt="" />
          </template>
        </el-table-column>
        <el-table-column
          prop="mobile_phone"
          label="手机号"
          align="center"
        ></el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              size="small"
              @click="
                saveProduct.type = 2;
                saveProduct.course_type = 0;
                saveProduct.target_id = row.id;
                saveTarget();
              "
            >
              添加
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      title="设置分享语"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
    >
      <el-form :model="coupon" label-width="100px" class="demo-ruleForm">
        <el-form-item label="分享标题">
          <el-input
            v-model="coupon.share_message.share_title"
            maxlength="8"
            show-word-limit
            placeholder="请输入分享标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="分享描述">
          <el-input
            v-model="coupon.share_message.share_desc"
            maxlength="8"
            show-word-limit
            placeholder="请输入分享描述"
          ></el-input>
        </el-form-item>

        <el-form-item label="分享图标">
          <el-upload
            class="avatar-uploader"
            :action="ossAction"
            :show-file-list="false"
            :http-request="uploadOSSRequest"
            :before-upload="beforeImageUpload"
          >
            <img
              v-if="coupon.share_message.share_icon"
              :src="coupon.share_message.share_icon"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="saveCouponShare()"
            :loading="updateLoading"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";

import {
  getCouponInfo,
  saveCouponGroup,
  couponProductList,
  screenProductList,
  saveProductInfo,
  couponProductDelete,
  saveShareExtend,
} from "@/api/coupon";

export default {
  data: function () {
    return {
      ossAction: "",
      dialogVisible: false,
      loading: false,
      updateLoading: false,
      showCouponGroupList: false,
      coupon: {
        id: this.$route.query.id,
        name: "",
        group: 0,
        share_message: {
          share_title: "",
          share_desc: "",
          share_icon: "",
        },
      },
      total: 0,
      query: {
        coupon_id: this.$route.query.id,
        page: 1,
        limit: 20,
      },
      list: [],
      search: {
        chooseOrgVisible: false,
        chooseOrgVisible2: false,
        listLoading1: false,
        activeName: "19",
        query: {
          type: 0,
          search: "",
          page: 1,
          limit: 5,
          target_type: 19,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      saveProduct: {
        coupon_id: this.$route.query.id,
        target_id: 0,
        type: 0,
        course_type: 0,
        start_at: "",
        end_at: "",
        radio: 0,
      },
      targetOrderTimedialogVisible: false,
      type_value: 0
    };
  },
  created: function () {
    this.type_value = this.$route.query.type_value
    console.log(this.type_value)
    this.loading = true;
    this.getInfo();
  },
  mounted() {},
  methods: {
    getInfo() {
      getCouponInfo({
        id: this.$route.query.id,
      }).then((response) => {
        this.coupon = {
          id: response.data.id,
          name: response.data.name,
          group: response.data.group,
          share_message: {
            share_title:
              response.data.share_message == null
                ? ""
                : response.data.share_message.share_title,
            share_desc:
              response.data.share_message == null
                ? ""
                : response.data.share_message.share_desc,
            share_icon:
              response.data.share_message == null
                ? ""
                : response.data.share_message.share_icon,
          },
        };
        this.loading = false;
        if (this.coupon.group == 2) {
          this.showCouponGroupList = false;
        } else {
          this.showCouponGroupList = true;
          this.getList();
        }
      });
    },
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({ dir: "" }).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.coupon.share_message.share_icon = fileUrl;
        });
      });
    },
    couponProductDelete(id) {
      this.$confirm("确定执行删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          couponProductDelete({
            id: id,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    saveCouponShare() {
      saveShareExtend(this.coupon).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.getInfo();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
    saveTarget() {
      saveProductInfo(this.saveProduct).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "设置成功",
            type: "success",
          });
          this.getList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
        this.addEditFormOnClose();
        this.targetOrderTimedialogVisibleHandleClose();
        this.search.chooseOrgVisible = this.search.chooseOrgVisible2 = false;
      });
    },
    targetOrderTimedialogVisibleHandleClose() {
      this.targetOrderTimedialogVisible = false;
      this.saveProduct.radio = 0;
      this.saveProduct.start_at = "";
      this.saveProduct.end_at = "";
    },
    handleClick(tab, event) {
      this.search.query.target_type = Number(tab.name);
      this.searchData();
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.activeName = "19";
      this.search.query.type = 0;
      this.search.query.search = "";
      this.search.query.target_type = 19;
      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = this.search.chooseOrgVisible2 = false;
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      screenProductList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    getList() {
      this.loading = true;
      couponProductList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    setCouponGroup(event) {
      var msg = "";
      if (event == 2) {
        msg = "全体用户";
      } else {
        msg = "指定人群";
      }
      this.$confirm("确定要设置为" + msg + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          saveCouponGroup({
            id: this.coupon.id,
            group: event,
          }).then((response) => {
            if (response.status == 2000) {
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
              if (event == 2) {
                this.showCouponGroupList = false;
              } else {
                this.showCouponGroupList = true;
                this.getList();
              }
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch((e) => {
          if (event == 2) {
            this.coupon.group = 7;
          } else {
            this.coupon.group = 2;
          }
        });
    },
  },
};
</script>

<style>
.el-header,
.el-footer {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height: 60px;
  margin-top: 10px;
  font-size: 20px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>